var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        staticClass: "form add-identity-form",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.$emit("add-identity", {
              username: _vm.username,
              password: _vm.password
            })
          }
        }
      },
      [
        _c("div", { staticClass: "form-group" }, [
          _c("p", [
            _vm._v(" " + _vm._s(_vm.T.addContestUsernameAndPassword) + " ")
          ])
        ]),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            { staticClass: "w-100" },
            [
              _vm._v(" " + _vm._s(_vm.T.wordsIdentity) + " "),
              _c("font-awesome-icon", {
                attrs: {
                  title: _vm.T.profileAddIdentitiesTooltip,
                  icon: "info-circle"
                }
              }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.username,
                    expression: "username"
                  }
                ],
                staticClass: "form-control username-input",
                attrs: {
                  "data-identity-username": "",
                  autocomplete: "off",
                  size: "20",
                  type: "text"
                },
                domProps: { value: _vm.username },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.username = $event.target.value
                  }
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "w-100" }, [
            _vm._v(" " + _vm._s(_vm.T.loginPassword) + " "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password"
                }
              ],
              staticClass: "form-control password-input",
              attrs: {
                "data-identity-password": "",
                autocomplete: "off",
                size: "20",
                type: "password"
              },
              domProps: { value: _vm.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.password = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "form-group text-right" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "submit", "data-add-identity-button": "" }
            },
            [_vm._v(" " + _vm._s(_vm.T.wordsAddIdentity) + " ")]
          )
        ])
      ]
    ),
    _vm.identities.length == 0
      ? _c("div", [
          _c("div", { staticClass: "empty-category" }, [
            _vm._v(" " + _vm._s(_vm.T.profileIdentitiesEmpty) + " ")
          ])
        ])
      : _c("table", { staticClass: "table table-striped table-over" }, [
          _c("thead", [
            _c("tr", [_c("th", [_vm._v(_vm._s(_vm.T.wordsIdentity))])])
          ]),
          _c(
            "tbody",
            _vm._l(_vm.identities, function(identity) {
              return _c(
                "tr",
                {
                  key: identity.username,
                  attrs: { "data-added-identity-username": "" }
                },
                [_c("td", [_vm._v(_vm._s(identity.username))])]
              )
            }),
            0
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }